export default __webpack_public_path__ + "static/media/logo-new-job.0f501f65.png";